import { Extensions } from 'src/app/shared/extensions/extensions';
import { TACHOGRAPH_ROUTE } from './../../../service-category/_consts/service-category-route.const';
import { StcLeavingApplicationCanDeactivateGuard } from './../../stc/_guard/stc-leaving-application-can-deactivate-guard';
import { TranslateService } from '@ngx-translate/core';
import { Injectable, NgZone } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, forkJoin, of, interval, EMPTY } from 'rxjs';
import { filter, map, take, tap, first, mergeMap, repeatWhen, delay, expand, takeWhile } from 'rxjs/operators';
import { MY_ACCOUNT_ROUTE } from 'src/app/my-account/_consts/my-account-route.const';
import { LIST_APPLICATIONS_ROUTE } from 'src/app/my-account/list-applications/_consts/list-applications.route.const';
import { PaymentDto, PaymentDtoV2, PaymentStatus } from 'src/app/shared/models/payment/payment-dto.model';

import { PaymentConfirmationService } from './payment-confirmation.service';
import { AuthService } from 'src/app/core/auth';
import { data } from 'jquery';

@Injectable()
export class PaymentConfirmationResolver {
  isIndividual: boolean;
  attempCounter: number = 0;
  isBussiness: boolean;
  constructor(
    private paymentConfirmationService: PaymentConfirmationService,
    private auth: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  getPaymentInfo(id: string) {
    return this.paymentConfirmationService.getPaymentSummary$(id)
  }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<PaymentDtoV2> | Promise<PaymentDtoV2> | PaymentDtoV2 {
    return this.auth.state$.pipe(
      filter(state => state.status === 'initialized'),
      first(),
      tap((state) => {
        this.isIndividual = AuthService.isIndividualUser(state.user);
        this.isBussiness = AuthService.isBusinessUser(state.user);
      }),
      mergeMap(() => {
        if (route.queryParamMap.get('type') !== 'manual-payment') {
          return this.getPaymentInfo(route.paramMap.get('billid'))
            .pipe(
              expand(response => {
                if (response.paymentStatus === PaymentStatus.AUTHPENDING) {
                  return this.getPaymentInfo(route.paramMap.get('billid')).pipe(delay(3000));
                } else {
                  return EMPTY;
                }
              }),
              take(4),
              map((data: PaymentDtoV2) => {
                let toastrMessage: string;
                let toastrType: any;
                switch (data.paymentStatus) {
                  case PaymentStatus.AUTHACCEPTED:
                    toastrMessage = this.translate.instant('TOASTR.PAYMENT.PAYMENT_SUCCES');
                    toastrType = (message: string) => this.toastr.success(message);
                    break;
                  case PaymentStatus.AUTHPENDING:
                    toastrMessage = this.translate.instant('TOASTR.PAYMENT.PAYMENT_PENDING');
                    toastrType = (message: string) => this.toastr.info(message);
                    break;
                  case PaymentStatus.AUTHREJECTED:
                    toastrMessage = this.translate.instant('TOASTR.PAYMENT.PAYMENT_REJECTED');
                    toastrType = (message: string) => this.toastr.warning(message);
                    break;
                  default:
                    toastrMessage = null;
                    toastrType = (message: string) => this.toastr.info(message);
                }

                if ((this.isIndividual) && data.paymentStatus !== PaymentStatus.AUTHREJECTED) {
                  this.toastr.clear();
                  toastrType(toastrMessage);
                  return data;
                } else {
                  this.router.navigate(['/', MY_ACCOUNT_ROUTE, LIST_APPLICATIONS_ROUTE]).then(() => {
                    toastrType(toastrMessage);
                  });
                }
              })
            );
        } else {
          return this.paymentConfirmationService.getManualPaymentSummary$(route.paramMap.get('billid'));
        }
      })
    );
  }
}
